import { motion } from 'framer-motion';
import { Sun } from 'lucide-react';
import { DailyBriefingCard } from './DailyBriefingCard';
import { WeeklyQuestCard } from './WeeklyQuestCard';
import { WeatherWidget } from './WeatherWidget';
import { PatternDiscoveryCard } from './PatternDiscoveryCard';
import { DayPlanCard } from './DayPlanCard';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * "Heute mit Nanouk" — Mission-Control stack that groups the daily briefing
 * (what you should know) with the weekly quest (what you should pursue).
 * Both child cards self-hide when they have no data, so the whole stack
 * collapses gracefully on a brand-new account.
 */
export function TodayWithNanoukStack() {
    const { language } = useLanguage();

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="space-y-2.5"
            data-testid="today-with-nanouk-stack"
        >
            <div className="flex items-center gap-1.5 px-1">
                <Sun className="w-3.5 h-3.5 text-amber-500" />
                <h2 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">
                    {language === 'de' ? 'Heute mit Nanouk' : "Today with Nanouk"}
                </h2>
            </div>

            <WeatherWidget />
            <DayPlanCard />
            <PatternDiscoveryCard />
            <DailyBriefingCard />
            <WeeklyQuestCard />
        </motion.section>
    );
}
